import React, { useEffect } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  // Checkbox,
  Radio,
  RadioGroup,
  // Divider,
  // TextField,
  // InputAdornment,
  Collapse,
  // Select,
  // MenuItem,
  // Grid,
} from "@mui/material";
import RazorpaySvg from "./images/RazorpaySvg.js";
import {
  IMG_VISA as VisaCard,
  IMG_UPI as UPICard,
  IMG_MASTER as MasterCard,
  IMG_RUPAY as RupayCard,
} from "./imageConfig";
// import PaypalIcon from "./images/paypal-icon.png";
// import LockIcon from "@mui/icons-material/Lock";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
// import CustomAddressForm from "./CustomAddressForm.js";

const CheckoutPaymentSection = ({
  paymentMethod = "Razorpay",
  handlePaymentChange,
  shippingDetails = { country: "India" }, // Default to India if not provided
}) => {
  // const CreditCardForm = () => {
  //   return (
  //     <Box
  //       sx={{
  //         borderRadius: "8px",
  //         backgroundColor: "#f6f6f6",
  //         mt: 2,
  //       }}
  //     >
  //       {/* Card Number */}
  //       <TextField
  //         fullWidth
  //         placeholder="Card number"
  //         variant="outlined"
  //         sx={{ mb: 2 }}
  //         InputProps={{
  //           endAdornment: (
  //             <InputAdornment position="end">
  //               <LockIcon fontSize="small" />
  //             </InputAdornment>
  //           ),
  //           sx: {
  //             backgroundColor: "#fff",
  //             borderRadius: "8px",
  //           },
  //         }}
  //       />

  //       {/* Expiration + CVV */}
  //       <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
  //         <TextField
  //           fullWidth
  //           placeholder="Expiration date (MM / YY)"
  //           variant="outlined"
  //           InputProps={{
  //             sx: {
  //               backgroundColor: "#fff",
  //               borderRadius: "8px",
  //             },
  //           }}
  //         />
  //         <TextField
  //           fullWidth
  //           placeholder="Security code"
  //           variant="outlined"
  //           InputProps={{
  //             endAdornment: (
  //               <InputAdornment position="end">
  //                 <HelpOutlineIcon fontSize="small" />
  //               </InputAdornment>
  //             ),
  //             sx: {
  //               backgroundColor: "#fff",
  //               borderRadius: "8px",
  //             },
  //           }}
  //         />
  //       </Box>

  //       {/* Name on Card */}
  //       <TextField
  //         fullWidth
  //         placeholder="Name on card"
  //         variant="outlined"
  //         sx={{ mb: 2 }}
  //         InputProps={{
  //           sx: {
  //             backgroundColor: "#fff",
  //             borderRadius: "8px",
  //           },
  //         }}
  //       />

  //       {/* Use shipping address checkbox */}
  //       <FormControlLabel
  //         control={<Checkbox defaultChecked />}
  //         label="Use shipping address as billing address"
  //         sx={{ mt: 1 }}
  //       />
  //     </Box>
  //   );
  // };

  // Set payment method based on country
  useEffect(() => {
    if (shippingDetails.country === "Canada") {
      handlePaymentChange({ target: { value: "Paypal" } });
    } else if (!paymentMethod) {
      handlePaymentChange({ target: { value: "Razorpay" } });
    }
  }, [shippingDetails.country, paymentMethod, handlePaymentChange]);

  const isIndia = shippingDetails.country === "India";

  return (
    <Box sx={{ mt: 4 }}>
      {/* Payment Method Section */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Payment
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 2, color: "#666", fontSize: "14px" }}
        >
          All transactions are secure and encrypted.
        </Typography>

        {/* <Box
          sx={{
            flexDirection: "column",
            alignItems: "center",
            border: "1px solid rgb(229 229 229 / 39%)",
            borderRadius: "8px",
            backgroundColor: "rgb(229 229 229 / 39%)",
            p: 2,
          }}
        >
          <RadioGroup
            aria-labelledby="payment-method"
            name="payment-method"
            value={paymentMethod}
            onChange={handlePaymentChange}
          >
            <FormControlLabel
              value="Creditcard"
              checked
              control={
                <Radio
                  sx={{ color: "black", "&.Mui-checked": { color: "black" } }}
                />
              }
              label={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: 24,
                  }}
                >
                  <Typography sx={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                    Credit Card
                  </Typography>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <img src={UPICard} alt="UPI" width={38} height={24} />
                    <img src={VisaCard} alt="Visa" width={38} height={24} />
                    <img
                      src={MasterCard}
                      alt="MasterCard"
                      width={38}
                      height={24}
                    />
                    <img src={RupayCard} alt="Rupay" width={38} height={24} />
                    <Box
                      sx={{
                        border: "1px solid rgb(229 229 229 / 39%)",
                        borderRadius: "4px",
                        backgroundColor: "white",
                        width: 38,
                        height: 23,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography sx={{ fontSize: "12px" }}>+16</Typography>
                    </Box>
                  </Box>
                </Box>
              }
              sx={{ alignItems: "center", mb: 2 }}
            />
          </RadioGroup>
          <Divider />

          <CreditCardForm />
        </Box> */}

        {/* Show Razorpay only for India */}
        {isIndia && (
          <Box
            sx={{
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid rgb(229 229 229 / 39%)",
              borderRadius: "8px",
              backgroundColor: "rgb(229 229 229 / 39%)",
              p: 2,
              mb: 2,
            }}
          >
            <RadioGroup
              aria-labelledby="payment-method"
              name="payment-method"
              defaultChecked
              value={paymentMethod}
              onChange={handlePaymentChange}
            >
              <FormControlLabel
                value="Razorpay"
                control={
                  <Radio
                    sx={{ color: "black", "&.Mui-checked": { color: "black" } }}
                  />
                }
                label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        gap: 1,
                      }}
                    >
                    <Typography sx={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Razorpay Secure
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <img src={UPICard} alt="UPI" width={38} height={24} />
                      <img src={VisaCard} alt="Visa" width={38} height={24} />
                      <img
                        src={MasterCard}
                        alt="MasterCard"
                        width={38}
                        height={24}
                      />
                      <img src={RupayCard} alt="Rupay" width={38} height={24} />
                      <Box
                        sx={{
                          border: "1px solid rgb(229 229 229 / 39%)",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          width: 38,
                          height: 23,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography sx={{ fontSize: "12px" }}>+16</Typography>
                      </Box>
                    </Box>
                  </Box>
                }
                sx={{ alignItems: "center", mb: 2 }}
              />
            </RadioGroup>

            <Collapse in={paymentMethod === "Razorpay"}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mt: 2,
                  mb: 2,
                }}
              >
                <RazorpaySvg
                  style={{ marginBottom: 8 }}
                  width={80}
                  height={80}
                />
                <Typography
                  variant="body2"
                  sx={{ textAlign: "center", mt: 1, p: 2 }}
                >
                  After you review your order, you will be redirected to
                  Razorpay Secure (UPI, Cards, Wallets, NetBanking) to complete
                  your purchase securely.
                </Typography>
              </Box>
            </Collapse>
          </Box>
        )}

        <br />

        {/* Show PayPal for non-India countries */}
        {!isIndia && (
          <Box
            sx={{
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid rgb(229 229 229 / 39%)",
              borderRadius: "8px",
              backgroundColor: "rgb(229 229 229 / 39%)",
              p: 2,
            }}
          >
            <RadioGroup
              aria-labelledby="payment-method"
              name="payment-method"
              value={paymentMethod}
              onChange={handlePaymentChange}
            >
              <FormControlLabel
                value="Paypal"
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label={
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between", // This is key
                      alignItems: "center",
                    }}
                  >
                    {/* Left-aligned text */}
                    <Typography
                      sx={{
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        flexShrink: 0, // Prevent text from shrinking
                      }}
                    >
                      PayPal
                    </Typography>

                    {/* Right-aligned icon */}
                    <Box
                      sx={{
                        flexShrink: 0, // Prevent container from shrinking
                        marginLeft: "auto", // Push to right
                      }}
                    >
                      {/* <img
                      src={PaypalIcon}
                      alt="paypal"
                      style={{
                        width: "100px",
                        height: "100px", // Fixed height for consistency
                        objectFit: "contain",
                      }}
                    /> */}
                    </Box>
                  </Box>
                }
                sx={{
                  width: "100%", // Full width
                  "& .MuiFormControlLabel-label": {
                    // Target the label container
                    width: "100%",
                    marginLeft: "4px", // Space between radio and label
                  },
                }}
              />
            </RadioGroup>

            <Collapse in={paymentMethod === "Paypal"}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mt: 2,
                  mb: 2,
                }}
              >
                <RazorpaySvg
                  style={{ marginBottom: 8 }}
                  width={80}
                  height={80}
                />
                <Typography
                  variant="body2"
                  sx={{ textAlign: "center", mt: 1, p: 2 }}
                >
                  After clicking "Pay with PayPal", you will be redirected to
                  PayPal to complete your purchase securely.
                </Typography>
              </Box>
            </Collapse>
          </Box>
        )}

        {/* Billing Address Section */}
        {/* <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, mt: 4 }}>
          Billing address
        </Typography> */}

        {/* <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            border: "1px solid #ccc",
            p: 0,
            overflow: "hidden", // Ensures no rounding conflict
          }}
        >
          <RadioGroup
            value={useBillingAddress}
            onChange={(e) => handleBillingChange(e.target.value)}
          >
            <FormControlLabel
              value="same"
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="Same as shipping address"
              sx={{
                px: 1,
                py: 1,
                backgroundColor:
                  useBillingAddress === "same" ? "#f6f6f6" : "#fff",
                borderBottom: "1px solid #ccc",
                width: "100%",
                m: 0,
              }}
            />

            <FormControlLabel
              value="different"
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="Use a different billing address"
              sx={{
                px: 1,
                py: 1,
                backgroundColor:
                  useBillingAddress === "different" ? "#f6f6f6" : "#fff",
                width: "100%",
                m: 0,
              }}
            />
          </RadioGroup>

          <Collapse in={useBillingAddress === "different"}>
            <CustomAddressForm
              shippingDetails={shippingDetails}
              handleShippingChange={handleShippingChange}
            />
          </Collapse>
        </Box> */}
      </Box>
    </Box>
  );
};

export default CheckoutPaymentSection;
